
















































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { InteractionModel, VForm } from '@/app/shared/models';
@Component
export default class DialogCertificateComponent extends Vue {
  @Ref() private form!: VForm;

  private dialog = false;
  private loading = false;
  private email = '';

  private get refs() {
    return refsService;
  }

  private downloadCertificate() {
    if (this.refs._.isEmpty(this.refs.modules.policy.policy.CertificateUri))
      this.$toast.error(this.$t('toasts.certificate_download_error'));
    else
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac7'),
          this.$t('action_desc.ad8')
        )
      );
  }
  private resendCertificate() {
    this.loading = true;
    if (this.form && this.form.validate())
      this.refs.modules.policy
        .resendCertificateByPolicyId({
          policyId: this.refs.modules.policy.policy.Id,
          payload: {
            NewCertificate: false,
            Email: this.email,
          },
        })
        .then(() => {
          this.$toast(this.$t('toasts.certificate_resent_successfully'));
          this.refs.modules.ticket.SET_EDIT_RESEND_CERTIFICATE(true);
          this.refs.modules.ticket.createInteraction(
            new InteractionModel(
              this.$t('action_code.ac6'),
              this.$t('action_desc.ad7')
            )
          );
          this.dialog = false;
        })
        .catch((err) => {
          this.$toast.error('ERROR ? ', err);
          this.$toast.error(this.$t('toasts.certificate_resent_error'));
          this.refs.modules.ticket.createInteraction(
            new InteractionModel(
              this.$t('action_code.ac6'),
              this.$t('action_desc.ad6')
            )
          );
        })
        .finally(() => (this.loading = false));
  }

  @Watch('dialog')
  private onChangeDialog(value: boolean): void {
    if (value) {
      if (this.form) this.form.resetValidation();
      const email = this.refs._.find(
        this.refs.modules.policy.customer.Contacts,
        (contact) =>
          this.refs.enums.ContactType[contact.Type] ==
          this.refs.enums.ContactType.Email.toString()
      );
      this.email = email ? email.Value : '';
    }
  }
}
